import { buyPdf, buySpecialOffer } from '../services/api';
import { trackPdfPurchaseFailed } from '../services/analytics';

export const buttonHandlers = {

    downloadApp: (context, element) => {

        const email = context.formData?.get('email') ?? 'unknown';
        const link = "https://tryrino.onelink.me/QiRK?af_xp=custom&pid=fnlfx&c=fnlfx&deep_link_value=fnlfox_" + email

        window.location.href = link;
    },

    openLink: (context, element) => {
        if (element.url) {
            window.open(element.url, element.target || '_blank');
        }
    },

    scrollToTop: (context, element) => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        if (element.goToNext !== false) {
            context.goToNextScreen();
        }
    },

    goToScreen: (context, element) => {
        if (element.screenName) {
            console.log(`Navigate to screen: ${element.screenName}`);
            context.goToNextScreen();
        }
    },

    addBookAndContinue: async (context, element) => {

        if (context.setButtonLoading) {
            context.setButtonLoading('addBookAndContinue', true);
        }

        try {
            const paymentProvider = localStorage.getItem('paymentProvider');
            const customerID = localStorage.getItem('customerID');
            const email = context.formData?.get('email');
            const onboardingId = context.onboardingId;

            if (!email) {
                context.goToNextScreen();
                return;
            }

            if (paymentProvider !== 'solidgate' && (!customerID || customerID == undefined)) {
                context.goToNextScreen();
                return;
            }

            const data = await buyPdf(email, onboardingId, paymentProvider);

            if (data.status === 'succeeded' || data.status === 'processing') {
                context.goToNextScreen();
                return;
            } else {
                trackPdfPurchaseFailed({
                    onboardingId,
                    email,
                    paymentProvider,
                    data,
                });
                context.goToNextScreen();
            }
        } finally {
            if (context.setButtonLoading) {
                context.setButtonLoading('addBookAndContinue', false);
            }
        }
    },

    specialOffer: async (context, element) => {

        if (context.setButtonLoading) {
            context.setButtonLoading('specialOffer', true);
        }

        try {
            const paymentProvider = localStorage.getItem('paymentProvider');
            const customerID = localStorage.getItem('customerID');
            const email = context.formData?.get('email');
            const onboardingId = context.onboardingId;

            if (!email) {
                context.goToNextScreen();
                return;
            }

            if (paymentProvider !== 'solidgate' && (!customerID || customerID == undefined)) {
                context.goToNextScreen();
                return;
            }

            const screen = context.getCurrentScreen?.();
            const offer = screen?.elements?.find((el) => el.type === 'specialOffer');
            const price = parseFloat((offer?.price || '$19.99').replace(/[^0-9.]/g, ''));
            const description = offer?.description || undefined;

            const data = await buySpecialOffer(email, onboardingId, paymentProvider, price, description);

            if (data.status === 'succeeded' || data.status === 'processing') {
                context.updateGlobalAnswer?.(screen?.name, {
                    text: 'purchased',
                    value: 'purchased',
                    elementName: 'specialOffer',
                });
                context.goToNextScreen();
                return;
            } else {
                trackPdfPurchaseFailed({
                    onboardingId,
                    email,
                    paymentProvider,
                    data,
                });
                context.goToNextScreen();
            }
        }
        finally {
            if (context.setButtonLoading) {
                context.setButtonLoading('specialOffer', false);
            }
        }
    },

};

export const getButtonHandler = (handlerName) => {
    return buttonHandlers[handlerName] || null;
};
